"use strict";

var _slicedToArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useOptionCardHeight = function useOptionCardHeight() {
  var _react_1$useState = react_1.useState(),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      optionCardHeight = _react_1$useState2[0],
      setOptionCardHeight = _react_1$useState2[1];

  var ulRef = react_1.useRef(null);
  react_1.useEffect(function () {
    var ulEl = ulRef.current;
    if (!ulEl) return;
    var firstLiEl = ulEl.firstElementChild;
    if (!firstLiEl) return;
    var optionCardEl = firstLiEl.firstElementChild;
    if (!optionCardEl || !(optionCardEl instanceof HTMLElement) || optionCardEl.dataset.meta !== 'image-explanation-option') return;
    setOptionCardHeight(optionCardEl.clientHeight);
  });
  return {
    ulRef: ulRef,
    optionCardHeight: optionCardHeight
  };
};

exports.default = useOptionCardHeight;